<div fxLayout="column" fxFlexFill *ngIf="!loader">

    <div class="divider layout-padd-2 title-filter-date" ngClass.xs="layout-padd-5" #pageTitle>

        <span class="mat-title">{{'orderComponent.command'|translate}}</span>

        <div fxLayoutAlign="center center" class="filter-date-vignette primary clicked" (click)="this.filterDateAnimFlag = !this.filterDateAnimFlag" fxHide fxShow.xs>
            <i class="material-icons" *ngIf="!filterDateAnimFlag" style="color:white;">date_range</i>
            <i class="material-icons" *ngIf="filterDateAnimFlag" style="color:white;">keyboard_arrow_up</i>
        </div>

    </div>

    <div class="divider layout-padd-2" fxHide.xs>
        <app-filter-date-from-to [type]="'orders'" (setDataEvent)="setOrders($event)" (setLoaderEvent)='setOrderLoader($event)'>
        </app-filter-date-from-to>
    </div>

    <div [@toggleFilterDate]="getToggleFilterDate" class="cont-filter-date-fix" [ngStyle]="{'top.px': titlePositionTop}" fxHide fxShow.xs>
        <div class="layout-padd-2">
            <app-filter-date-from-to [type]="'orders'" (setDataEvent)="setOrders($event)" (setLoaderEvent)='setOrderLoader($event)'>
            </app-filter-date-from-to>
        </div>
    </div>

    <div fxFlex class="scrolled">

        <div class="scrolled-y">

            <table mat-table [dataSource]="dataSource" class="full-w clicked" ngClass.xs="fix-w-table" matSort>

                <ng-container matColumnDef="order_level">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'orderComponent.status'|translate}}  </th>
                    <td mat-cell *matCellDef="let order">
                        <div fxLayout="row" fxLayoutAlign="start center ">
                            <mat-chip-list>
                                <mat-chip selected [ngStyle]="{background: order.level.color}">{{order.level.name | uppercase}}</mat-chip>
                            </mat-chip-list>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="date_creation">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'orderComponent.doat'|translate}}  </th>
                    <td mat-cell *matCellDef="let order">
                        {{order.date_creation | dateFilter:"DD-MM-YYYY"}} | {{order.date_creation | dateFilter:"HH:mm"}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="user_denomination">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'orderComponent.merchant'|translate}}  </th>
                    <td mat-cell *matCellDef="let order">
                        <div fxLayout="column">
                            <span>{{order.user_account.denomination | uppercase}} </span>
                            <div fxLayout="row">
                                <span class="mat-caption">{{order.point_of_sale.denomination | uppercase}}&nbsp;&nbsp;|&nbsp;&nbsp;{{order.sale_method.name | uppercase}}</span>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <!-- <ng-container matColumnDef="point_of_sale_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Point de vente </th>
                    <td mat-cell *matCellDef="let order"> {{order.point_of_sale.denomination | uppercase}} </td>
                </ng-container> -->
                <!--
                <ng-container matColumnDef="sale_method_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Mode de vente </th>
                    <td mat-cell *matCellDef="let order"> {{order.sale_method.name | uppercase}} </td>
                </ng-container> -->

                <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'orderComponent.total'|translate}}  </th>
                    <td mat-cell *matCellDef="let order"> {{order.total_str}} </td>
                </ng-container>

                <ng-container matColumnDef="icon" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let order">
                        <mat-icon class="primary-ico clicked" matTooltip="{{'orderComponent.details'|translate}}" (click)="openSideOrder(order)" matTooltipPosition="below" angulartics2On="click" angularticsAction="openOrderDetails" angularticsCategory="clientOrders">
                            search</mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="print">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let order">
                        <div fxLayoutAlign="center center" class="myDisabledUserKey">
                            <mat-icon class="great-ico clicked" matTooltip="{{'fidelityComponent.print'|translate}}" matTooltipPosition="below" (click)="goPrint(order.user_account.user_key, order.id)" angulartics2On="click" angularticsAction="openPrintOrder" angularticsCategory="clientOrders">print
                            </mat-icon>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>

            <div fxLayoutAlign="center center" class="layout-padd" *ngIf="!orderLoader && !loader && dataSource.data.length < 1">
                <span class="mat-subheading-1">{{'orderComponent.noOrder'|translate}}</span>
            </div>

            <app-popup-loader [flagLoading]="orderLoader" [size]="30" [statusMessage]="'orderComponent.messageLoaderGetOrder'|translate" [type]="'line'"></app-popup-loader>

        </div>

        <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>

    </div>

</div>
